import type { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    link: {
      cursor: 'pointer',
      color: theme.palette.primary.main,
      '&:hover': {
        textDecoration: 'underline',
        color: theme.palette.primary.dark
      }
    },
    privacy: {
      paddingRight: 20,
      '@media (max-width: 414px)': {
        paddingRight: 0
      }
    }
  });

export default styles;
